const RichiestaScadutaPage: React.FC = () => {
	const goToHome = () => {
		window.location.href = "https://buffettifinance.com/";
	};

	return (
		<div className="d-flex align-items-center justify-content-center flex-fill m-5">
			<div className="process-terminated m-lg-0 mt-5 mx-4">
				<div className="d-flex align-items-center gap-3 mb-4">
					<div className="d-flex flex-column align-items-center">
						<i className="icon fa-solid fa-times rounded-4 d-flex justify-content-center align-items-center fs-1 bg-danger"></i>
					</div>
					<div className="col-10">
						<h1>Richiesta Scaduta</h1>
					</div>
				</div>
				<div>
					<p className="text-secondary">Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
					<button className="btn btn btn-dark mt-3" onClick={goToHome}>
						Vai a home
					</button>
				</div>
			</div>
		</div>
	);
};
export default RichiestaScadutaPage;
